<template>
  <button :class="`${size}`">
    <div
      v-if="showIcon"
      class="icon"
    >
      <slot name="icon" />
    </div>
    <span class="text">
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  props: {
    showIcon: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'sm',
    }
  },
}
</script>

<style lang="scss" scoped>
button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 185px;
  background-color: #FFFFFF;
  color: #37B2A8;
  border: 2px solid #37B2A8;
  border-radius: 0.75rem;
  line-height: 1;
  letter-spacing: -0.5px;
  transition: .25s;

  &:hover {
    border-color: #1993AE;
    color: #1993AE;

    > .icon :deep(path) {
      stroke: #1993AE;
    }
  }

  &.sm {
    font-size: 14px;
    padding: 0.25rem 1.5rem;
  }

  &.md {
    font-size: 16px;
    padding: .75rem 1.5rem;
  }

  &.lg {
    font-size: 18px;
    padding: 1.5rem;
  }

  > .icon {
    margin-right: .5rem;

    :deep(path) {
      stroke: #37B2A8
    }
  }
}
</style>
